import React from "react";
import { cn } from "../../lib/cn";

export interface CardProps {
  interactive?: boolean;
  padding?: number | string;
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
}

/** claudesign surface card. Base = lit-from-above edge + soft drop;
 *  `interactive` lifts on hover. Mirrors the `.card` polish in ommuse-theme.css. */
export const Card: React.FC<CardProps> = ({
  interactive,
  padding = 20,
  className,
  onClick,
  children,
}) => (
  <div
    onClick={onClick}
    style={{ padding }}
    className={cn(
      "bg-surface border border-border-soft rounded-md",
      "shadow-[var(--edge-hi),0_1px_2px_rgba(0,0,0,.3)]",
      interactive &&
        "cursor-pointer transition-[transform,box-shadow] duration-150 hover:-translate-y-[3px] hover:shadow-[var(--edge-hi),0_14px_34px_-12px_rgba(0,0,0,.65)]",
      className,
    )}
  >
    {children}
  </div>
);

export default Card;
